import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import type { BannerHolder } from '@omq/types';

import { Dialog } from '@admin/shared/components/dialogs/dialog';

// create styles for component
const useStyles = makeStyles(() => {
  return {
    // iframe holder
    banner: {
      width: 830,
      height: 600,
      border: 'none',
    },
  };
});

const banner: BannerHolder | null = window.defaultData.banner || null;

/**
 * Shows a banner when set in the backend.
 *
 * @returns {JSX.Element}
 */
export const Banner = (): JSX.Element => {
  const styles = useStyles();
  const [showBanner, setShowBanner] = useState<boolean>(banner?.href?.length > 0);

  // check if banner is set
  if (banner === null) {
    return null;
  }

  // check if banner should be blocking
  if (banner.permanent) {
    // blocking banner
    return (
      <Dialog title="" open={true}>
        <iframe className={styles.banner} src={banner.href} />
      </Dialog>
    );
  } else {
    // banner with close button
    return (
      <Dialog title="" open={showBanner} onClose={() => setShowBanner(false)}>
        <iframe className={styles.banner} src={banner.href} />
      </Dialog>
    );
  }
};
